import { useState } from "react";
import PropTypes from "prop-types";
import FeaturedCategoryHeaderAccordion from "./FeaturedCategoryHeaderAccordion";
import CategoryHeaderMedia from "../CategoryHeaderMedia/index.js";
import FeaturedCategoryHeaderTitleOverlay from "./FeaturedCategoryHeaderTitleOverlay";
import { VIDEO_HEADER } from "../constants.js";
import {
  getHeaderTitle,
  getHeaderDisplayText,
} from "../CategoryHeader/helpers.js";
import * as types from "../CategoryHeaderMedia/constants.js";
import styles from "./FeaturedCategoryHeaderHero.css";

const FeaturedCategoryHeaderHero = ({
  category,
  hasVisualCategories,
  hideDescription = false,
  mediaType,
  scrollFunction,
  viewportCategory,
  featuredHeaderData,
}) => {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const { headerTitle, friendlyName, headerBody, headerHtmlEncoded } = category;
  const header = getHeaderTitle({
    headerTitle,
    friendlyName,
    headerHtmlEncoded,
  });
  const headerDisplayText = getHeaderDisplayText(featuredHeaderData);

  const toggleDescription = () => {
    setIsDescriptionOpen(!isDescriptionOpen);
  };

  return (
    <div id={VIDEO_HEADER} className={styles.heroHeader}>
      <div className={styles.heroHeaderContainer}>
        <CategoryHeaderMedia
          mediaType={mediaType}
          viewportCategory={viewportCategory}
          featuredHeaderData={featuredHeaderData}
        />
        <FeaturedCategoryHeaderTitleOverlay
          headerTitle={header}
          headerDisplayText={headerDisplayText}
          scrollFunction={scrollFunction}
        />
      </div>
      {category.headerBody && !hasVisualCategories && !hideDescription && (
        <FeaturedCategoryHeaderAccordion
          content={headerBody}
          onClick={toggleDescription}
          isOpen={isDescriptionOpen}
        />
      )}
    </div>
  );
};

FeaturedCategoryHeaderHero.propTypes = {
  hasVisualCategories: PropTypes.bool,
  hideDescription: PropTypes.bool,
  category: PropTypes.shape({
    id: PropTypes.number,
    headerBody: PropTypes.string,
    friendlyName: PropTypes.string,
    headerHtmlEncoded: PropTypes.string,
    headerTitle: PropTypes.string,
  }).isRequired,
  mediaType: PropTypes.oneOf(Object.values(types)).isRequired,
  scrollFunction: PropTypes.func.isRequired,
  viewportCategory: PropTypes.string.isRequired,
  featuredHeaderData: PropTypes.shape({
    app: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
    displayText: PropTypes.string,
    isEnabled: PropTypes.bool,
    web: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
  }),
};

export default FeaturedCategoryHeaderHero;
